
import { defineComponent } from "vue";
import BackgroundBlobs from "@/components/BackgroundBlobs.vue";

export default defineComponent({
  name: "DenyAccess",
  components: { BackgroundBlobs },
});
